import GeneratedMailFilterStore from "./generated/GeneratedMailFilterStore"

class MailFilterStore extends GeneratedMailFilterStore {

}

export const mailFilterStore = new MailFilterStore()
